import { RootPaths } from "@src/appV2/App/paths";

import { EARNINGS_PATH } from "../Earnings/paths";

export const PAYMENT_DETAILS_PATH = `${EARNINGS_PATH}/payment/:paymentId`;
export const PAYMENT_DETAILS_FULL_PATH = `${RootPaths.APP_V2_HOME}/${PAYMENT_DETAILS_PATH}`;
